/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileAppSharedNotificationStatus200,
  GetApiV1NotificationMobileAppSharedNotificationStatus401,
  GetApiV1NotificationMobileAppSharedNotificationStatusQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedNotificationStatus.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileAppSharedNotificationStatus200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedNotificationStatus200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileAppSharedNotificationStatus401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppSharedNotificationStatus401>;

export const getApiV1NotificationMobileAppSharedNotificationStatusQueryResponseSchema =
  z.lazy(
    () => getApiV1NotificationMobileAppSharedNotificationStatus200Schema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedNotificationStatusQueryResponse>;
